import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import apiClient from '../api/client';
import conectedLogo from '../assets/logo-conectedit.png';
import './LoginPage.css';

const ResetPasswordPage: React.FC = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError('');
    if (password !== confirm) return setError('Las contraseñas no coinciden.');
    if (password.length < 8) return setError('La contraseña debe tener al menos 8 caracteres.');
    setBusy(true);
    try {
      const response = await apiClient.post('/auth/reset-password', { token, password });
      setMessage(response.data.message);
    } catch (requestError: any) {
      setError(requestError.response?.data?.message || 'El enlace es inválido o venció.');
    } finally {
      setBusy(false);
    }
  };

  return <div className="login-container"><div className="login-card"><div className="login-header"><div className="login-product-mark standalone-mark"><img src={conectedLogo} alt="ConectedIT Software Factory" /></div><span className="login-mobile-brand standalone-brand">Recibos Digitales</span><h1>Crear nueva contraseña</h1><p>Elegí una clave personal de al menos 8 caracteres.</p></div>{message ? <div className="login-form"><div className="success-message">{message}</div><Link className="login-button login-button-link" to="/login">Ingresar</Link></div> : <form className="login-form" onSubmit={submit}>{error && <div className="error-message">{error}</div>}{!token && <div className="error-message">El enlace no contiene un código válido.</div>}<div className="form-group"><label htmlFor="password">Nueva contraseña</label><input id="password" type="password" value={password} onChange={(event) => setPassword(event.target.value)} required minLength={8} disabled={busy || !token} /></div><div className="form-group"><label htmlFor="confirm">Repetir contraseña</label><input id="confirm" type="password" value={confirm} onChange={(event) => setConfirm(event.target.value)} required minLength={8} disabled={busy || !token} /></div><button className="login-button" disabled={busy || !token}>{busy ? 'Guardando…' : 'Guardar contraseña'}</button><Link className="login-link" to="/login">Volver al inicio de sesión</Link></form>}</div></div>;
};

export default ResetPasswordPage;
